export const ProfileIconForm = () => {
    return(
        <svg xmlns="http://www.w3.org/2000/svg" width="21" height="21" fill="none">
            <path fill="#546EDB" fillOpacity=".5" d="M10.5 0C4.701 0 0 4.701 0 10.5S4.701 21 10.5 21 21 16.299 21 10.5 16.299 0 10.5 0Zm0 4.102a2.81 2.81 0 1 1 0 5.621 2.81 2.81 0 0 1 0-5.621Zm3.766 12.796H6.734c-1.384 0-2.292-1.454-1.677-2.694a6.074 6.074 0 0 1 10.886 0c.615 1.24-.293 2.694-1.677 2.694Z"/>
        </svg>
    )
}